import { Component, effect, model, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar'
import { RouterLink } from "@angular/router";
import { SessionService } from '../../services/session-service';
import { MatStepperModule } from "@angular/material/stepper";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { HelpFaqDialogComponent } from '../util/help-faq-dialog-component/help-faq-dialog-component';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EligibilitySession } from '../../models/eligibility-session';
import { DisplayMode } from '../session-sites-component/session-sites-component';
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from "@angular/material/menu";

@Component({
  selector: 'app-header-component',
  imports: [MatToolbarModule, RouterLink, FormsModule, MatButtonModule, MatStepperModule, MatDividerModule, MatIconModule, MatTooltipModule, MatMenuModule],
  templateUrl: './header-component.html',
  styleUrl: './header-component.css',
})
export class HeaderComponent {
  readonly session = signal<EligibilitySession | null>(null);
  public displayMode = model<DisplayMode>('addressValidation');
  public readonly DISPLAY_MODE_OPTIONS = [
    {name: 'Fiabilisation', value: 'addressValidation'},
    {name: 'Éligibilité technique', value: 'technicalEligibility'},
    {name: 'Éligibilité commerciale', value: 'commercialEligibility'},
  ];

  constructor(
    public readonly sessionService: SessionService,
    private dialog: MatDialog
  ) {
    effect(() => {
      this.session.set(this.sessionService.currentSession());
    });
  }

  openHelp(): void {
    this.dialog.open(HelpFaqDialogComponent, {
      width: '80%',
      maxWidth: '95vw'
    });
  }
}
